/* eslint-disable no-undef */
/* eslint-disable no-nested-ternary */

import Cookies from 'js-cookie';
import nativeProxy from '@nativeApp/nativeProxy';
import { createTraceData } from '@cvte/easy-report';
import Util, { isInEnPC } from './index';
import axios from './axios';

const DataReport = function () {
  if (typeof window === 'undefined') {
    return;
  }

  // TODO:旧项目逻辑照搬，后续进行逻辑整理改进>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  this.hasQRcode = false;
  this.isFromDetail = false;
  // TODO:旧项目逻辑照搬，后续进行逻辑整理改进<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

  this.dataReportId = window.__INITIAL_STATE__.dataReportId;

  const isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
  let device = '';

  if (nativeProxy.isInApp()) {
    device = 'ENM';
  } else if (isInEnPC()) {
    device = 'ENPC';
  } else {
    device = isMobile ? '移动端new' : 'PC端new';
  }

  this.dataParams = {
    device,
    $tid: Cookies.get('userId') || Cookies.get('fingerprint') || 'nobody',
    $is_user: Cookies.get('userId') ? 1 : '',
    username: Cookies.get('userId') || 'nobody',
    $longitude: Cookies.get('longitude') || '',
    $latitude: Cookies.get('latitude') || '',
    stageId: Cookies.get('stageId') || '',
    stageName: Cookies.get('stageName') || '',
    subjectId: Cookies.get('subjectId') || '',
    subjectName: Cookies.get('subjectName') || '',
    referer: document.referrer || '',
    isLogin: Cookies.get('isLogin'),
    channel: (function () {
      const channel =
        Util.getUrlParam('channel') || Cookies.get('channel') || Cookies.get('entry') || '';
      // if (channel && !/^\w+$/.test(channel)) {
      //   channel = 'format_error';
      // }
      return channel;
    })(),
  };

  // 关闭获取定位信息功能(暂时注释代码，以防后续需要重新开启)
  // eslint-disable-next-line max-len
  // !this.dataParams.$longitude && Cookies.get('geolocation') !== 'false' && navigator.geolocation && navigator.geolocation.getCurrentPosition(function (pos) {
  //   try {
  //     var longitude = pos.coords.longitude;
  //     var latitude = pos.coords.latitude;
  //     Cookies.set('geolocation', true, { path: '/', expires: 30 });
  //     Cookies.set('longitude', longitude, { path: '/', expires: 30 });
  //     Cookies.set('latitude', latitude, { path: '/', expires: 30 });
  //     Object.assign(DataReport.dataParams, {
  //       $longitude: longitude,
  //       $latitude: latitude
  //     });
  //   } catch (e) {
  //     Cookies.set('geolocation', false, { path: '/', expires: 7 });
  //   }
  // }, function (error) {
  //   Cookies.set('geolocation', false, { path: '/', expires: 7 });
  // }, {
  //   timeout: 3000,
  // });
};

DataReport.prototype = {
  setDataParams(config) {
    this.dataParams = {
      ...this.dataParams,
      ...config,
    };
  },
  // 数据上报入口 异步
  dataReportLater(name, params) {
    const _that = this;
    const reportParams = { ..._that.dataParams, ...params, ...createTraceData() };
    _faq.push(['trackEvent', name, reportParams, _that.dataReportId]);
  },
  // 数据上报入口 同步
  dataReportNow(name, params) {
    const _that = this;
    const reportParams = { ..._that.dataParams, ...params, ...createTraceData() };
    if (window.$fa) {
      window.$fa.trackEvent(name, reportParams, _that.dataReportId);
    } else {
      _that.dataReportLater(name, params);
    }
  },
  // 点击在线学习横幅
  reportClickWhichBanner(obj) {
    this.dataReportNow('banner_click', obj);
  },
  // 课组分类点击
  reportCatalogType(obj) {
    this.dataReportNow('catalog_type_click', obj);
  },
  // 课组分类页标签点击（非首页）
  reportCatalogTypePageClickLabel(obj) {
    this.dataReportNow('catalog_type_label_click', obj);
  },
  // 课组分类页课程点击
  reportCourseCatalogType(obj) {
    this.dataReportNow('course_catalog_type_click', obj);
  },
  // 移动端首页浏览 / pc端在线学习
  reportHomePage() {
    this.dataReportNow('home_view_page', {});
  },
  // 移动端首页/pc端在线学习 模块曝光
  reportHomeComponentExposure(obj) {
    this.dataReportNow('home_component_exposure', obj);
  },
  // 移动端首页/pc端在线学习按键点击
  reportHomeKeyboardClick(obj) {
    this.dataReportNow('home_keyboard_click', obj);
  },

  // 咨询页浏览
  reportNewsList() {
    this.dataReportNow('news_list', {});
  },

  // 面包屑点击
  reportBreadcrumbsClick(obj) {
    this.dataReportNow('breadcrumbs_click', obj);
  },
  // 移动端首页/pc端在线学习页 课组分类推荐点击
  reportHomeCoursegroupCategoryRecommendClick(obj) {
    this.dataReportNow('home_coursegroup_category_recommend_click', obj);
  },
  // 移动端首页/pc端在线学习页 个性化推荐点击
  reportHomePersonaliseRecommendClick(obj) {
    this.dataReportNow('home_personalise_recommend_click', obj);
  },
  // 底栏菜单点击
  reportBottomMenuClick(obj) {
    this.dataReportNow('bottom_menu_click', obj);
  },
  // 顶部菜单点击
  reportHeaderMenuClick(obj) {
    this.dataReportNow('header_menu_click', obj);
  },
  // 分类详情页浏览
  reportCategoryDetailPage(obj) {
    this.dataReportNow('category_detail_view_page', obj);
  },
  // 返回栏点击
  reportReturnBarClick(obj) {
    this.dataReportNow('return_bar_click', obj);
  },
  // 搜索推荐浏览
  reportSearchInitView() {
    this.dataReportNow('search_init_view', {});
  },
  // 搜索标题页浏览
  reportSearchChangeView() {
    this.dataReportNow('search_change_view', {});
  },
  // 搜索结果页浏览
  reportSearchResultView(obj) {
    this.dataReportNow('search_result_view', obj);
  },
  // 搜索结果点击
  reportSearchResultClick(obj) {
    this.dataReportNow('search_result_click', obj);
  },
  // 搜索结果展示
  reportShowResultClick(obj) {
    this.dataReportNow('show_search_result', obj);
  },
  // 搜索按钮点击
  reportSearchBtnClick(obj) {
    this.dataReportNow('search_btn_click', obj);
  },

  // 精彩讨论 home_discuss_click
  reporthomeDiscussClick(obj) {
    this.dataReportNow('home_discuss_click', obj);
  },

  // 排序点击
  reportAscButtonClick(obj) {
    this.dataReportNow('asc_button_click', obj);
  },

  // 登陆意向
  reportLogin(obj) {
    this.initGetQRCode();
    this.dataReportNow('login_intention', obj);
  },

  // 注册意向
  reportRegister(obj) {
    this.initGetQRCode();
    this.dataReportNow('register_intention', obj);
  },

  // TODO:旧项目逻辑照搬，后续进行逻辑整理改进>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  initFromHomePage() {
    this.initGetActiveData();
    this.renameActivePostion();
    this.renameActiveName();
    this.reportHomePage();
  },

  initGetQRCode() {
    const _that = this;
    let qrCode = '';
    if (Util.getUrlParam('dataReport')) {
      qrCode = decodeURIComponent(Util.getUrlParam('dataReport'));
    } else if (sessionStorage.qrCode) {
      qrCode = sessionStorage.qrCode;
    }
    // eslint-disable-next-line eqeqeq
    if (qrCode != '') {
      _that.hasQRcode = true;
      _that.dataParams.entry = '来自扫码';
      _that.dataParams = { ..._that.dataParams, ...Util.stringToJson(qrCode) };
    }
  },

  initGetActiveData() {
    const activeData = decodeURIComponent(Util.getUrlParam('activeData'));
    // eslint-disable-next-line eqeqeq
    if (activeData != '') {
      const param = Util.stringToJson(activeData);
      this.dataParams = { ...this.dataParams, ...param };
    }
  },

  // 在url中添加参数
  addUrlParam(dataUrl, key, value) {
    let _dataUrl = dataUrl.toString();
    const hasParam = _dataUrl.indexOf('?');
    if (hasParam >= 0) {
      _dataUrl = `${_dataUrl}&${key}=${encodeURIComponent(value)}`;
      return _dataUrl;
    }
    _dataUrl = `${_dataUrl}?${key}=${encodeURIComponent(value)}`;
    return _dataUrl;
  },

  getLinkParam(obj) {
    const params = { ...this.dataParams, ...obj };
    if (this.isFromDetail && !params.entry) {
      params.entry =
        typeof entry !== 'undefined' ? entry : this.hasQRcode ? 'fromDetail_1' : 'fromDetail_2';
    }
    if (/zone/i.test(location.pathname)) {
      params.channel = 'zhuanqu';
      params.zonename =
        window.__INITIAL_STATE__.title || window.__INITIAL_STATE__.detail.data.name || '';
      Cookies.set('channel', 'zhuanqu', { path: '/zone' });
    } else {
      params.channel = '';
      params.zonename = '';
    }

    params.activityName =
      typeof activityName !== 'undefined' ? activityName : params.activityName || '';
    const value = Util.jsonToString(params);
    return value;
  },

  renameActivePostion() {
    if (!this.dataParams.activityPostion) {
      return;
    }

    switch (this.dataParams.activityPostion) {
      case 'activity_beike':
        this.dataParams.activityPostion = '活动页备课';
        break;
      case 'activity_xianchang':
        this.dataParams.activityPostion = '活动页说课';
        break;
      case 'activity_luping':
        this.dataParams.activityPostion = '活动页录屏';
        break;
      case 'activity_shizhan':
        this.dataParams.activityPostion = '获奖案例';
        break;
      case 'activity_more':
        this.dataParams.activityPostion = '活动页更多';
        break;
      case 'activity_footer':
        this.dataParams.activityPostion = '活动页底部banner';
        break;
      default:
        break;
    }
  },

  renameActiveName() {
    if (!this.dataParams.activityName) {
      return;
    }

    if (this.dataParams.activityName === 'openCourse') {
      this.dataParams.activityName = '公开课活动页';
    }
  },

  // TODO:旧项目逻辑照搬，后续进行逻辑整理改进<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

  /* 获取用户专区身份 */
  getUserAuth() {
    return new Promise(function (resolve) {
      const userUid = UserInfo.resourceid;
      if (window.__INITIAL_STATE__.specialZoneUid && userUid) {
        axios
          .get(`/v1/special/zone/user/role/${window.__INITIAL_STATE__.specialZoneUid}/${userUid}`)
          .then((resp) => {
            if (resp.statusCode === 200) {
              resolve(resp.data === 0 ? '学员' : resp.data === 1 ? '讲师' : '非专区学员');
            }
          });
      } else {
        resolve('非专区学员');
      }
    });
  },

  /* 专区首页打开 */
  reportAllZonePageView(obj) {
    this.dataReportNow('all_zone_page_view', obj);
  },
  /* 单个专区打开 */
  reportSingleZonePageView(obj) {
    this.getUserAuth().then((data) => {
      // eslint-disable-next-line no-param-reassign
      obj.user_auth = data;
      this.dataReportNow('single_zone_page_view', obj);
    });
  },
  // 专区管理按钮点击
  reportZoneControBtnClick(obj) {
    this.dataReportNow('zone_contro_btn_click', obj);
  },
  // 自定义添加按钮点击
  reportZoneCustomBtnClick(obj) {
    this.dataReportNow('zone_custom_btn_click', obj);
  },
  // 专区管理页面浏览
  reportZoneControView(obj) {
    this.dataReportNow('zone_contro_view', obj);
  },
  // 专区自定义课程页浏览
  reportZoneCustomView(obj) {
    this.dataReportNow('zone_custom_view', obj);
  },
  // 专区添加课程意向
  reportZoneChangeListIntent(obj) {
    this.dataReportNow('zone_change_list_intent', obj);
  },
  // 专区添加课程成功
  reportZoneAddListSuccess(obj) {
    this.dataReportNow('zone_add_list_successs', obj);
  },
  // 专区添加课程搜索
  reportZoneAddListSearch(obj) {
    this.dataReportNow('zone_add_list_search', obj);
  },
  // 专区邀请点击
  reportZoneInviteClick(obj) {
    this.dataReportNow('zone_invite_click', obj);
  },
  // 加入专区
  reportAddZoneSuccess(obj) {
    this.dataReportNow('add_zone_success', obj);
  },
  // 专区邀请扫描二维码
  reportZoneInviteQrcode(obj) {
    this.dataReportNow('zoneInvite_qrcode', obj);
  },
  // 专区用户删除
  reportZoneUserWithJoinedOrNot(obj) {
    this.dataReportNow('importUser_delete', obj);
  },

  // 专区详情页版块tab栏点击事件
  reportZoneSectionTabClick(obj) {
    this.dataReportNow('zone_tab_click', obj);
  },

  // 专区详情页贡献榜单点击事件
  reportZoneContributionClick(obj) {
    this.dataReportNow('zone_contribution_click', obj);
  },

  // 课程观看时长
  reportVideoPlayedDuration(obj) {
    const param = Object.assign(obj, { entry: this.hasQRcode ? '来自扫码' : '非扫码' });
    this.dataReportNow('video_watch_time', param);
  },
  // 课程观看进度(技术实现：上报看课起点时间+每十秒上报一次用户是否仍在看课)
  reportVideoCurrentTime(obj) {
    const param = Object.assign(obj, { entry: this.hasQRcode ? '来自扫码' : '非扫码' });
    this.dataReportNow('video_watch_position', param);
  },
  // 课程视频播放（包含点击播放按键、自动播放、2分钟试听）
  reportVideoPlayEvent(obj) {
    const param = Object.assign(obj, { entry: this.hasQRcode ? '来自扫码' : '非扫码' });
    this.dataReportNow('watch_video', param);
  },

  // 课组页面浏览
  reportGroupBrowse(obj) {
    this.dataReportNow('group_view_page', obj);
  },

  // 课程播放页面浏览
  reportCoursePlayerBrowse(obj) {
    this.dataReportNow('course_view_page', obj);
  },

  // 激活证书
  // reportActCertificate: function(obj) {
  //   const { courseTypes, groupId, groupName } = obj;
  //   this.dataReportNow('activate_certificate', {
  //    courseTypes, groupId, groupName
  //   })
  // },

  // 认证证书
  reportCertifyCertificate(obj) {
    this.dataReportNow('certify_certificate', obj);
  },

  // 点击特训营页“加微信群”
  reportAddStudyGroup(obj) {
    this.dataReportNow('add_study_group', obj);
  },

  // 访问页面
  reportPage(obj) {
    this.dataReportNow('view_page', obj);
  },

  // 课组分类页课组曝光
  reportCategoryDetailViewItem(obj) {
    this.dataReportNow('category_detail_view_page_item', obj);
  },

  // 特训营打卡
  reportCampSign(obj) {
    this.dataReportNow('camp_train_sign', obj);
  },

  // 通过打卡活动
  reportCampSignFinish(obj) {
    this.dataReportNow('camp_train_sign_finish', obj);
  },

  // 删除留言
  reportDelComment(obj) {
    this.dataReportNow('del_comment', obj);
  },

  // 删除笔记评论
  reportDelNoteComment(obj) {
    this.dataReportNow('del_note_comment', obj);
  },

  // 新增笔记评论
  reportAddNoteComment(obj) {
    this.dataReportNow('note_comment', obj);
  },

  // 点赞
  reportGood(obj) {
    this.dataReportNow('thanks', obj);
  },

  // 取消
  reportCancelGood(obj) {
    this.dataReportNow('cancel_good', obj);
  },

  // 删除打卡进度
  reportDelSign(obj) {
    this.dataReportNow('del_camp_sign', obj);
  },

  // 提交留言
  reportHandinComment(obj) {
    this.dataReportNow('qa_event', obj);
  },

  reportZoneCapsuleLog(obj) {
    this.dataReportNow('seewoedu_zone_capsule_log', obj);
  },

  reportZoneCapsule(obj) {
    this.dataReportNow('seewoedu_zone_capsule', obj);
  },

  // 播放器画质切换
  reportVideoSharpChange(obj) {
    this.dataReportNow('sharp_change', obj);
  },

  // 播放器倍速切换
  reportVideoSpeedChange(obj) {
    this.dataReportNow('speed_change', obj);
  },

  // 播放器触发全屏
  reportVideoFullscreen(obj) {
    this.dataReportNow('fullscreen', obj);
  },

  // 在播放区手势拉动进度
  reportVideoGestureProgross(obj) {
    this.dataReportNow('gesture_progross', obj);
  },

  // 在播放区手势全屏
  reportVideoGestureFullscreen(obj) {
    this.dataReportNow('gesture_fullscreen', obj);
  },

  // 在播放区手势播放/暂停
  reportVideoGesturePause(obj) {
    this.dataReportNow('gesture_pause', obj);
  },

  // 评论意向
  reportCommentIntention(obj) {
    this.dataReportNow('qa_intention', obj);
  },

  // 回复意向
  reportReplyIntention(obj) {
    this.dataReportNow('reply_intention', obj);
  },

  // 查看评论
  reportViewComment(obj) {
    this.dataReportNow('view_comment', obj);
  },

  // 跳转课组
  reportCommentJumpGroup(obj) {
    this.dataReportNow('jump_group', obj);
  },

  // 跳转话题
  reportCommentJumpTopic(obj) {
    this.dataReportNow('jump_point_mobile', obj);
  },

  // tap栏点击
  reportTapClick(obj) {
    this.dataReportNow('tap_click', obj);
  },
  // 专区相关的上报(PC端) ======
  // 专区 点击换一换
  reportPCZoneChange(obj) {
    this.dataReportNow('zone_PC_change', obj);
  },

  // 专区 点击订阅
  reportPCZoneSubscribe(obj) {
    this.dataReportNow('zone_PC_subscribe', obj);
  },

  // 专区 点击课程
  reportPCZoneCourse(obj) {
    this.dataReportNow('zone_PC_course', obj);
  },

  // 专区 查看更多
  reportPCZoneMore(obj) {
    this.dataReportNow('zone_PC_more', obj);
  },

  // 专区 点击专区名字
  reportPCZoneClickZone(obj) {
    this.dataReportNow('zone_PC_clickzone', obj);
  },

  // 专区 点击我的订阅中的专区
  reportPCZoneMysubscribeDetail(obj) {
    this.dataReportNow('zone_PC_mysubscribe_detail', obj);
  },

  // 专区 点击barnar
  reportPCZoneBarner(obj) {
    this.dataReportNow('zone_PC_banner', obj);
  },

  // 专区 取消订阅
  reportPCCancelSubscribe(obj) {
    this.dataReportNow('zone_PC_unsubscribe_intention', obj);
  },

  // 专区 取消订阅-确认
  reportPCCancelSubscribeComfirm(obj) {
    this.dataReportNow('zone_PC_unsubscribe_confirm', obj);
  },

  // 专区管理后台 订阅数据详情 如 点击新增订阅，点击取消订阅，点击净增订阅
  reportPCZoneSubscribeData(obj) {
    this.dataReportNow('zone_subscribe_data', obj);
  },

  // 专区管理后台 点击订阅相关时间
  reportPCZoneSubscribeTime(obj) {
    this.dataReportNow('zone_subscribe_time', obj);
  },

  // 专区相关的上报(移动端) ======
  // 专区订阅
  reportMobileZoneSubscribe(obj) {
    this.dataReportNow('zone_mobile_subscribe', obj);
  },

  // 专区信息流点击课程
  reportMobileZoneCourse(obj) {
    this.dataReportNow('zone_mobile_course', obj);
  },

  // 专区信息流点击专区
  reportMobileClickZone(obj) {
    this.dataReportNow('zone_mobile_clickzone', obj);
  },

  // 点击我的订阅中的专区
  reportZoneMobileMysubscribeDetail(obj) {
    this.dataReportNow('zone_mobile_mysubscribe_detail', obj);
  },

  // 专区搜索
  reportZoneMobileSearch(obj) {
    this.dataReportNow('zone_mobile_search', obj);
  },

  // 点击查看更多专区
  reportZoneMobileMore(obj) {
    this.dataReportNow('zone_mobile_more', obj);
  },

  // 点击取消订阅
  reportZoneMobileUnsubscribeIntention(obj) {
    this.dataReportNow('zone_mobile_unsubscribe_intention', obj);
  },

  // 点击确认取消订阅
  reportZoneMobileUnsubscribeConfirm(obj) {
    this.dataReportNow('zone_mobile_unsubscribe_confirm', obj);
  },

  // 发表话题评论
  reportTopicCommentPublish(obj) {
    this.dataReportNow('point_mobile_view', obj);
  },

  // 话题投票
  reportPointMobileVote(obj) {
    this.dataReportNow('point_mobile_vote', obj);
  },

  pointMobileViewIntention(obj) {
    this.dataReportNow('point_mobile_view_intention', obj);
  },

  pointMobileShare(obj) {
    this.dataReportNow('point_mobile_share', obj);
  },

  pointMoblileThumbup(obj) {
    this.dataReportNow('point_moblile_thumbup', obj);
  },

  pointMobileTap(obj) {
    this.dataReportNow('point_mobile_tap', obj);
  },

  pointMobileViewDeleted(obj) {
    this.dataReportNow('point_mobile_view_deleted', obj);
  },

  pointMobileTime(obj) {
    this.dataReportNow('point_mobile_time', obj);
  },

  jumpPointPc(obj) {
    this.dataReportNow('jump_point_pc', obj);
  },
  // 首页新手引导
  reportHomeGuide(obj) {
    this.dataReportNow('tips_mobile_index', obj);
  },

  // 兑换中心点击签到
  reportTaskSign(obj) {
    this.dataReportNow('mobile_task_sign', obj);
  },

  // 点击积分账单
  reportIntergration(obj) {
    this.dataReportNow('mobile_task_intergration_list', obj);
  },

  // 点击去完成
  reportTaskGet(obj) {
    this.dataReportNow('mobile_task_get', obj);
  },

  // 点击领积分
  reportTaskFinish(obj) {
    this.dataReportNow('mobile_task_finish', obj);
  },

  // 扫描PC端二维码进入兑换中心
  reportTaskFromPC(obj) {
    this.dataReportNow('PC_task_tomobile', obj);
  },

  // 点击幸运抽奖
  reportMobileTaskLottery() {
    this.dataReportNow('mobile_task_lottery');
  },

  // 点击赚积分
  reportMobileTaskIntergration(obj) {
    this.dataReportNow('mobile_task_intergration', obj);
  },

  // 查看商品详情
  reportMobileTaskGoodsDetail(obj) {
    this.dataReportNow('mobile_task_goods_detail', obj);
  },

  // 兑换意向
  reportMobileTaskGoodsIntention(obj) {
    this.dataReportNow('mobile_task_goods_intention', obj);
  },

  // 成功兑换商品
  reportMobileTaskGoodsPurchase(obj) {
    this.dataReportNow('mobile_task_goods_purchase', obj);
  },

  // 点击兑换记录
  reportMobileTaskChangeRecord() {
    this.dataReportNow('mobile_task_change_record');
  },

  // 点击虚拟商品【去使用】
  reportMobileTaskVirtualUse(obj) {
    this.dataReportNow('mobile_task_virtual_use', obj);
  },

  // 点击优惠券商品【复制】
  reportMobileTaskCouponCopy(obj) {
    this.dataReportNow('mobile_task_coupon_copy', obj);
  },
  // 话题投票
  reportHotTopicVote(obj) {
    this.dataReportNow('hotpoint_mobile_vote', obj);
  },
  // 话题投票
  reportTopicDetail(obj) {
    this.dataReportNow('hotpoint_mobile_detail', obj);
  },
  // 广场tab点击
  reportSqureTabClick(obj) {
    this.dataReportNow('squre_type_click', obj);
  },
  // 广场分享
  reportSqureShare(obj) {
    this.dataReportNow('squre_share', obj);
  },
  // 话题详情点击回复评论
  reportPointMobileViewReplyIntention(obj) {
    this.dataReportNow('point_mobile_view_reply_intention', obj);
  },
  // 话题详情评论回复(成功发表回复)
  reportPointMobileViewReply(obj) {
    this.dataReportNow('point_mobile_view_reply', obj);
  },
  // 话题详情评论分享
  reportPointMobileViewShare(obj) {
    this.dataReportNow('point_mobile_view_share', obj);
  },
  // 话题详情点击展开更多
  reportPointMobileViewMore(obj) {
    this.dataReportNow('point_mobile_view_more', obj);
  },
  // 扫描海报二维码访问话题详情页
  reportPointMobileViewScan(obj) {
    this.dataReportNow('point_mobile_view_scan', obj);
  },
  // 个人中心栏目点击（移动）
  reportPersonalMobileClick(obj) {
    this.dataReportNow('personal_mobile_click', obj);
  },
  // enpc落地页banner点击
  reportENPCBannerClick(obj) {
    this.dataReportNow('ENPC_banner', obj);
  },
  // enpc落地页点击学习记录
  reportENPCRecordClick(obj) {
    this.dataReportNow('ENPC_studyrecord', obj);
  },
  // enpc落地页点击训练营列表
  reportENPCampListClick(obj) {
    this.dataReportNow('ENPC_camplist', obj);
  },
  // enpc落地页点击更多课例（到学苑首页）
  reportENPTrainEntryClick(obj) {
    this.dataReportNow('ENPC_seewoedu', obj);
  },
  // enpc落地页点击【去报名】
  reportENPCampSignupClick(obj) {
    this.dataReportNow('ENPC_camp_signup', obj);
  },
  // enpc落地页点击【去学习】
  reportENPCampStudyClick(obj) {
    this.dataReportNow('ENPC_camp_study', obj);
  },
  // enpc落地页点击搜索
  reportENPSearchClick(obj) {
    this.dataReportNow('ENPC_search', obj);
  },
  // enpc落地页点击【查看更多】
  reportENPMoreClick(obj) {
    this.dataReportNow('ENPC_morecourse', obj);
  },
  // enpc落地页点击【课程】
  reportENPCourseClick(obj) {
    this.dataReportNow('ENPC_course', obj);
  },
  // 笔记详情页浏览
  reportCampTrainNoteView(obj) {
    this.dataReportNow('camp_train_note_view', obj);
  },
  // 打卡笔记页浏览
  reportCampSignView(obj) {
    this.dataReportNow('camp_train_sign_view', obj);
  },
  // 用户进行分享操作
  reportSharePage(obj) {
    this.dataReportNow('share_page', obj);
  },
  // 学习导流-学习导流页曝光
  reportStudyPageView(obj) {
    this.dataReportNow('studypage_view', obj);
  },
  // 学习导流-训练营点击
  reportCampView(obj) {
    this.dataReportNow('camp_view', obj);
  },
  // 学习导流-用户广告位点击
  reportUserAdClick(obj) {
    this.dataReportNow('user_ad_click', obj);
  },
  // 实名认证提交身份证
  reportRealNameIDSubmit() {
    this.dataReportNow('ID_submit');
  },
  // 实名认证提交个人信息
  reportRealNameInfoSubmit() {
    this.dataReportNow('information_submit');
  },
  // 合同列表-点击合同
  reportContractClick(obj) {
    this.dataReportNow('contrat_click', obj);
  },
  // 合同-点击签署
  reportSignContractClick() {
    this.dataReportNow('sign_contract_click');
  },
  // 合同-点击发送站内信
  reportDownloadContractClick(obj) {
    this.dataReportNow('download_contract_click', obj);
  },
  // 兑换商品详情-点击导流按钮（悬浮窗）
  reportMobileTaskBotton(obj) {
    this.dataReportNow('mobile_task_botton', obj);
  },
  // 课程购买点击上报
  reportClickBuyNew(obj) {
    this.dataReportNow('click_buy_new', obj);
  },
  // 首页闪屏点击
  reportHomeStartupClick(obj) {
    this.dataReportNow('home_startup_click', obj);
  },
  // 首页闪屏曝光
  reportHomeStartupView(obj) {
    this.dataReportNow('home_startup_view', obj);
  },
  // 首页闪屏关闭曝光
  reportHomeStartupClose(obj) {
    this.dataReportNow('home_startup_close', obj);
  },
  // pc端首页曝光
  reportPCHomeView(obj) {
    this.dataReportNow('PC_home_view', obj);
  },
  // pc端首页海报横幅点击
  reportPCHomeBannerClick(obj) {
    this.dataReportNow('PC_home_banner_click', obj);
  },
  // pc端首页课程体系点击
  reportPCHomeCourseSystemClick(obj) {
    this.dataReportNow('PC_home_course_click', obj);
  },
  // pc端首页图片报道点击
  reportPCPicNewsClick(obj) {
    this.dataReportNow('PC_home_pic_news_click', obj);
  },
  // pc端首页文字报道点击
  reportPCTextNewsClick(obj) {
    this.dataReportNow('PC_home_news_click', obj);
  },
  reportFirstViewVideoCanplay(obj) {
    this.dataReportNow('fe_frist_view_video_canplay', obj);
  },
  reportChangeCourseVideoCanplay(obj) {
    this.dataReportNow('fe_change_course_video_canplay', obj);
  },
  reportFirstViewVideoLoadmetadata(obj) {
    this.dataReportNow('fe_frist_view_video_loadmetadata', obj);
  },
  reportChangeCourseVideoLoadmetadata(obj) {
    this.dataReportNow('fe_change_course_video_loadmetadata', obj);
  },
  // 课件大作业 点击+号
  reportPcCampEn5Upload(obj) {
    this.dataReportNow('pc_camp_en5_upload', obj);
  },
  // 课件大作业 点击协议
  reportPcCampEn5Agreement(obj) {
    this.dataReportNow('pc_camp_en5_upload_agreement', obj);
  },
  // 课件大作业 点击确认
  reportPcCampEn5UploadConfirm(obj) {
    this.dataReportNow('pc_camp_en5_upload_confirm', obj);
  },
  // 点击 「更换作业」
  reportPcCampEn5UploadChange(obj) {
    this.dataReportNow('pc_camp_en5_upload_change', obj);
  },
  // 课组目录点击 「上传作业」
  reportPcCampEn5UploadClick(obj) {
    this.dataReportNow('pc_camp_en5_upload_click', obj);
  },
  // 休息提醒拉动进度条
  reportCampRestPush(obj) {
    this.dataReportNow('camp_rest_push', obj);
  },
  // 关闭休息提醒
  reportCampRestClose(obj) {
    this.dataReportNow('camp_rest_close', obj);
  },
  // 休息提醒曝光
  reportCampRestView(obj) {
    this.dataReportNow('camp_rest_view', obj);
  },
  // en5课件下载
  reportEnDownload(obj) {
    this.dataReportNow('en_download', obj);
  },
  // en5课件预览
  reportEnPreview(obj) {
    this.dataReportNow('en5_preview', obj);
  },
  // 点击课件按钮
  reportEnCoursewareClick(obj) {
    this.dataReportNow('en_courseware_click', obj);
  },
  // 上报交互行为
  reportUserInteractionEvent(events) {
    this.dataReportNow('user_interaction_event', { events });
  },
  // 杏坛官网首页曝光
  reportPcXingtanIndexView() {
    this.dataReportNow('pc_xingtan_index_view');
  },
  // 杏坛官网-用户点击播放视频按钮
  reportPcXingtanIndexVideoClick() {
    this.dataReportNow('pc_xingtan_index_video_click');
  },
  // 杏坛官网-用户点击了解详情
  reportPcXingtanDetailsClick() {
    this.dataReportNow('pc_xingtan_details_click');
  },
  // 杏坛首页-用户点击人物故事
  reportPcXingtanIndexStoryClick(obj) {
    this.dataReportNow('pc_xingtan_index_story_click', obj);
  },
  // 杏坛首页-用户点击查看更多故事
  reportPcXingtanIndexStoryMore() {
    this.dataReportNow('pc_xingtan_index_story_more');
  },
  // 杏坛-故事列表曝光
  reportPcXingtanStoryListView() {
    this.dataReportNow('pc_xingtan_story_list_view');
  },
  // 杏坛-用户点击故事列表故事
  reportPcXingtanStoryListClick(obj) {
    this.dataReportNow('pc_xingtan_story_list_click', obj);
  },
  // 杏坛-用户点击分享故事按钮
  reportPcXingtanStoryListShare(obj) {
    this.dataReportNow('pc_xingtan_story_list_share', obj);
  },
  // 杏坛-用户点击报名
  reportPcXingtanIndevAttend() {
    this.dataReportNow('pc_xingtan_index_attend');
  },
  // 杏坛-用户点击继续进修
  reportPcXintanIndexStudy() {
    this.dataReportNow('pc_xingtan_index_study');
  },
  // 顶栏下拉菜单曝光
  reportHeaderMenuView(obj) {
    this.dataReportNow('pc_personal_centre_menu_view', obj);
  },
  // 顶栏下拉菜单点击
  reportHeaderDropdwonMenuClick(obj) {
    this.dataReportNow('pc_personal_centre_menu_click', obj);
  },
  // 搜索结果列表曝光
  reportPcSearchListView(obj) {
    this.dataReportLater('pc_search_list_view', obj);
  },
  // 搜索结果列表点击
  reportPcSearchListClick(obj) {
    this.dataReportNow('pc_search_list_click', obj);
  },
  // 点击搜索分类
  reportPcSearchTabClick(obj) {
    this.dataReportNow('pc_search_tap_click', obj);
  },
  // 搜索页中名师推荐课程曝光
  reportPcSearchLectureCoursView(obj) {
    this.dataReportLater('pc_search_lecture_course_view', obj);
  },
  // 点击搜索名师推荐
  reportPcSearchLectureCoursClick(obj) {
    this.dataReportNow('pc_search_lecture_course_click', obj);
  },
  // 搜索中点击专区订阅
  reportPcSearchZoneSubscribe(obj) {
    this.dataReportNow('pc_search_zone_subscribe', obj);
  },
  // 热门搜索曝光
  reportPcSearchHotView(obj) {
    this.dataReportNow('pc_search_hot_view', obj);
  },
  // 搜索记录点击
  reportPcSearchRecordClick(obj) {
    this.dataReportNow('pc_search_record_click', obj);
  },
  // 点击热门搜索
  reportPcSearchHotClick(obj) {
    this.dataReportNow('pc_search_hot_click', obj);
  },
  // 点击搜索按钮
  reportPcSearchClick(obj) {
    this.dataReportNow('pc_seach_click', obj);
  },
};

export default new DataReport();
